module.exports = __webpack_public_path__ + "img/nose-02.3447abf7.svg";